export const getChildrenLength = (item) => {
  let len = 0;
  len += (item.children || []).length;
  (item.children || []).forEach((da) => {
    len += getChildrenLength(da);
  });
  return len;
};

const map = {};
const hotelMap = {};

export const findChild = (list, rootId, onlyHotels) => {
  list.forEach((item) => {
    if ((onlyHotels === true && item.type !== 4) || !onlyHotels) {
      item.children = [];
      map[item.id] = item;
      if (item.id !== 0) {
        hotelMap[item.hotelId] = item;
      }
    }
  });
  const ret = [];
  for (let i in map) {
    const item = map[i];
    if (map[item.pid]) {
      map[item.pid].children.push(item);
    }
    if (item.pid === rootId) {
      ret.push(item);
    }
  }
  const result = [];
  for (let i = 0, length = ret.length; i < length; i++) {
    if (ret[i].pid === rootId && ret[i].type !== 3 && ret[i].children.length === 0) {
      continue;
    } else {
      result.push(ret[i]);
    }
  }
  return result;
};

export const getDataById = (treeData, id) => {
  return treeData[map[id].index];
};

export const getDataByHotelId = (treeData, id) => {
  return treeData[hotelMap[id].index];
};

let index = 0;
export const init = () => {
  index = 0;
};
export const flatern = (node, level, pIndex) => {
  let ret = [];
  const childLength = node.children.length;
  const da = Object.assign(node, {
    index,
    pIndex: pIndex || 0,
    level: level,
    visible: true,
    expanded: true,
    checkStatus: {
      checked: 0,//0：未选中，1：半选，2：选中
      childChecked: childLength === 0 ? null : [childLength, 0, 0],
      childLength: childLength
    }
  });
  ret.push(da);
  level = level + 1;
  let _pIndex = index;
  node.children.forEach((n) => {
    index++;
    ret = ret.concat(flatern(n, level, _pIndex));
  });
  return ret;
};



// WEBPACK FOOTER //
// ./src/ui/AgencyTree/agencyUtils.js